import { make as NotificationBase } from 'components/library/Notification.bs';
import * as React from 'react';

export enum Type {
  Error = 0,
  Info = 1,
  Success = 2,
  Warning = 3,
}

interface Props {
  type?: Type;
  title: string;
  description?: string;
}

const Notification = ({ type = Type.Success, title, description = '' }: Props) => (
  <NotificationBase notificationType={type} title={title} description={description} />
);

export default Notification;
